@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;

.InputNumber {
  @extend %form-control-background;
  @extend %form-control-border;
  @extend %form-control-disabled;
  @extend %form-control-font;

  margin: 0;
  min-width: 3em;
  padding: 0 12px 0 16px;
  box-sizing: border-box;
  height: $component-height;
  outline: none;
  cursor: text;

  &.sm {
    height: 18px;
    min-width: 2.5em;
    padding: 0 4px;
    font-size: 12px;
    text-align: center;
    appearance: textfield;
    -moz-appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &:hover {
    box-shadow: 0 0 0 3px $hover-shadow-primary;
  }

  &:focus,
  &:focus-within {
      border-color: $color-primary-purple;
      box-shadow: 0 0 0 3px $hover-shadow-primary;
  }

  &:read-only {
    // within a disabled fieldset
    color: $theme-color-sub-text;
    cursor: pointer;

    &:hover,
    &:focus,
    &:focus-within {
      box-shadow: none;
    }

    &:disabled {
      cursor: default;
    }

    &::placeholder {
      color: $theme-color-text;
    }
  }
}
